export interface BlobURLToFileOptions {
  type?: string;
  filename?: string;
}

export async function blobUrlToFile(mediaBlobUrl: string, options: BlobURLToFileOptions = {}) {
  const mediaBlob = await fetch(mediaBlobUrl).then(res => res.blob());
  return new File([mediaBlob], options.filename ?? 'output.mp4', { type: options.type ?? 'video/mp4' });
}

export default blobUrlToFile;
